export const ScaleIconSvg = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4v16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 8h12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 8l-3 6h6L6 8z" stroke={color} strokeWidth="2" strokeLinejoin="round"/>
    <path d="M18 8l-3 6h6l-3-6z" stroke={color} strokeWidth="2" strokeLinejoin="round"/>
    <path d="M8 20h8" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
